module.exports = "/_next/static/images/413d19835b404292b1f6f697d294ef5a-card-and-phone-3d-lg@3x.jpg.webp";